const StopSvg = (props) => {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <circle cx="12" cy="12" r="9" stroke="#ff665c" strokeWidth="2" />
      <path d="M7.5 12H16.5" stroke="#ff665c" strokeWidth="2" />
    </svg>
  )
}

export default StopSvg
